<mat-card>
  <mat-card-header style="background-color:#F5F5F5">
    <mat-card-title style="line-height:3px">Tank Battery Capacity</mat-card-title>
  </mat-card-header>
  <mat-card-content>

    <div>
      <kendo-grid [data]="dGrid1">
        <kendo-grid-column field="Label" title="">
        </kendo-grid-column>
        <kendo-grid-column field="BatteryCapacity" title="80% Battery Capacity">
        </kendo-grid-column>
        <kendo-grid-column field="ProductionStart" title="Production at Start">
        </kendo-grid-column>
        <kendo-grid-column field="ProductionNeedBy" title="Production at Needby">
        </kendo-grid-column>
        <kendo-grid-column field="TotalNewProduction" title="Total New Production">
        </kendo-grid-column>
        <kendo-grid-column field="DeferredVolumes" title="Deferred Volumes">
        </kendo-grid-column>
      </kendo-grid>
    </div>

  </mat-card-content>
</mat-card>

<mat-card>
  <mat-card-header style="background-color:#F5F5F5">
    <mat-card-title style="line-height:3px">Major Equipment</mat-card-title>
  </mat-card-header>
  <mat-card-content>
    <div>
      <kendo-grid [data]="dGrid2">
        <kendo-grid-column field="EquipmentType" title="">
        </kendo-grid-column>
        <kendo-grid-column field="QuantityStart" title="80% Battery Capacity">
        </kendo-grid-column>
        <kendo-grid-column field="OilCapacity" title="Production at Start">
        </kendo-grid-column>
        <kendo-grid-column field="GasCapacity" title="Production at Start">
        </kendo-grid-column>
        <kendo-grid-column field="WaterCapacity" title="Production at Needby">
        </kendo-grid-column>
        <kendo-grid-column field="RequiredEquipment" title="Total New Production">
        </kendo-grid-column>
        <kendo-grid-column field="EquimentNeedOverrider" title="Deferred Volumes">
        </kendo-grid-column>
        <kendo-grid-column field="NewCapacity" title="Deferred Volumes">
        </kendo-grid-column>

      </kendo-grid>
    </div>

  </mat-card-content>
</mat-card>